var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ReadonlyService } from './readonly.service';
var FormReadonlyComponent = /** @class */ (function (_super) {
    __extends(FormReadonlyComponent, _super);
    function FormReadonlyComponent(service, baseService, cdRef, rservice) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cdRef = cdRef;
        _this.rservice = rservice;
        _this.vals = [];
        return _this;
    }
    FormReadonlyComponent.prototype.ngOnInit = function () {
        var _this = this;
        // super.ngOnInit();
        this.refSubsc = this.service.refObservable.subscribe(function (flg) {
            if (flg) {
                _this.setValue();
                _this.cdRef.detectChanges();
            }
        });
    };
    FormReadonlyComponent.prototype.ngOnChanges = function (changes) {
        this.setValue();
    };
    FormReadonlyComponent.prototype.setValue = function () {
        var val = this.rservice.getValue(this.componentName, this.col, this.val, 'readonly');
        this.vals = [];
        if (val instanceof Array) {
            if (val.length > 0) {
                this.vals = val;
            }
            else {
                this.vals.push(this.msg['FormReadonlyComponent.label.unselected']);
            }
        }
        else if (typeof val !== 'undefined' && val !== null && val !== '') {
            this.vals.push(val);
        }
        else {
            switch (this.col.controlType) {
                case 'label':
                    break;
                case 'select':
                case 'select2':
                case 'select2ajax':
                case 'radio':
                case 'file':
                case 'checkbox':
                case 'oneCheckbox':
                    this.vals.push(this.msg['FormReadonlyComponent.label.unselected']);
                    break;
                default:
                    this.vals.push(this.msg['FormReadonlyComponent.label.notEntered']);
                    break;
            }
        }
    };
    FormReadonlyComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.refSubsc) {
            this.refSubsc.unsubscribe();
        }
    };
    FormReadonlyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-formreadonly',
                    template: '<ng-template ngFor let-v [ngForOf]="vals" let-index="index">'
                        + '<column-formlabel *ngIf="col.controlType === \'label\'; else elseBlock" [key]="key" [componentName]="componentName" [index]="index" [col]="col" [val]="v" [msg]="msg"></column-formlabel>'
                        + '<ng-template #elseBlock><pre class="formReadOnly" [key]="key" [col]="col" columnDir>{{ v }}</pre><br *ngIf="col.params?.vertical === true && index < vals.length - 1"></ng-template>'
                        + '</ng-template>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FormReadonlyComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ChangeDetectorRef },
        { type: ReadonlyService }
    ]; };
    return FormReadonlyComponent;
}(ColumnBaseComponent));
export { FormReadonlyComponent };
//# sourceMappingURL=readonly.component.js.map